// extracted by mini-css-extract-plugin
export default {"top_menu_text":"MenuDesktop_top_menu_text__NrKer","top_menu_link_underline":"MenuDesktop_top_menu_link_underline__k3Plm"};